export const options = {
    scale: {
        lineTension: 100,
        gridLines: {
            color: 'rgba(255, 255, 255, 0.1)'
        },
        angleLines: {
            color: 'rgba(255, 255, 255, 0.1)'
        },
        ticks: {
            beginAtZero: true,
            display: false
        },
        labels: {
            display: false,
            fontSize: 20,
            fontColor: 'rgba(255, 255, 255, 0.5)',
            fontFamily: 'icomoon'
        },
        pointLabels: {
            fontSize: 20,
            display: false,
            fontColor: 'rgba(255, 255, 255, 0.5)',
            fontFamily: 'icomoon'
        }

    },
    tooltips: {
        enabled: false,
        // custom: function (tooltipModel) {

        //     // Tooltip Element
        //     let tooltipEl = document.getElementById('chartjs-tooltip');

        //     // Create element on first render
        //     if (!tooltipEl) {
        //         tooltipEl = document.createElement('div');
        //         tooltipEl.id = 'chartjs-tooltip';
        //         tooltipEl.innerHTML = "<div class='inner'></table>";
        //         document.body.appendChild(tooltipEl);
        //     }

        //     if (tooltipModel.dataPoints) {
        //         // Set Text
        //         const index = tooltipModel.dataPoints[0].index;
        //         const data = tooltipModel.body[0].lines[0].split(':')[1];
        //         let html = '';

        //         switch (index) {
        //             case 0:
        //                 html = 'Work Intensity: ' + data;
        //                 break;
        //             case 1:
        //                 html = 'Task Discretion: ' + data;
        //                 break;
        //             case 2:
        //                 html = 'Worker Voice: ' + data;
        //                 break;
        //             case 3:
        //                 html = 'Autonomy Over Working Time: ' + data;
        //                 break;
        //             case 4:
        //                 html = 'Work-Life Balance: ' + data;
        //                 break;
        //             case 5:
        //                 html = 'Managerial Support: ' + data;
        //                 break;
        //             case 6:
        //                 html = 'Required Learning: ' + data;
        //                 break;
        //             case 7:
        //                 html = 'Promotion Prospects: ' + data;
        //                 break;
        //             case 8:
        //                 html = 'Job Insecurity: ' + data;
        //                 break;
        //             case 9:
        //                 html = 'Pay: ' + data;
        //                 break;
        //         }

        //         // set inner html
        //         var tableRoot = tooltipEl.querySelector('.inner');
        //         tableRoot.innerHTML = html;


        //         // `this` will be the overall tooltip
        //         var position = this._chart.canvas.getBoundingClientRect();

        //         // Display, position, and set styles for font
        //         tooltipEl.style.opacity = 1;
        //         tooltipEl.style.backgroundColor = '#000000';
        //         tooltipEl.style.color = '#ffffff';
        //         tooltipEl.style.position = 'absolute';
        //         tooltipEl.style.left = position.left + tooltipModel.caretX + 'px';
        //         tooltipEl.style.top = position.top + tooltipModel.caretY + 'px';
        //         tooltipEl.style.zIndex = '3';
        //         tooltipEl.style.fontFamily = 'Poppins',
        //         tooltipEl.style.fontSize = '14px';
        //         tooltipEl.style.fontWeight = '700';
        //         tooltipEl.style.fontStyle = tooltipModel._bodyFontStyle;
        //         tooltipEl.style.padding = '10px';
        //     }
        // }
    },
    legend: {
        display: false
    },
    pointStyle: 'circle',
    events: ['mousemove', 'click'],
    responsive: true,
    maintainAspectRatio: true
};




// WEBPACK FOOTER //
// ./src/Results/options.js